angular.module('core')
  .service('guardianApi', ['$http', 'cancelableResourceFactory', '$state', 'authentication', 'nameFilter', 'highlightsApi', 'transformResponse', 'timeframe', 'taggable',
    function ($http, $cancelableResourceFactory, $state, $authentication, $nameFilter, $highlightsApi, $transformResponse, $timeframe, taggable) {
    var self = this;

    var guardianNavigationMapping = function(body) {
      try {
        var guardian = JSON.parse(body);

        guardian.type = 'guardian';

        taggable(guardian);

        return guardian;
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var guardianMapping = function(guardian) {
      taggable(guardian);

      return guardian;
    };

    var GuardianNavigation = $cancelableResourceFactory.createCacheableResource('GuardianNavigation', '/n/customer_info', {
      id: '@id'
    }, {
      query: {
        cache: true,
        url: '/n/customer_info',
        method: 'GET',
        isArray: true,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationQuery('guardian', body, guardianNavigationMapping); // because customer_info returns back with customers entity
        }
      },
      get: {
        cache: true,
        url: '/n/customer_info',
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationGet('guardian', body, guardianMapping); // because customer_info returns back with customers entity
        }
      }
    });


    /**************************************************************/
    /*                          Api                               */
    /**************************************************************/
    self.getGuardian = function(student_id, callback) {
      var params = _.pick($state.params, ['districtId', 'classroomId']);
      params.studentId = student_id;

      var promises = GuardianNavigation.get(params);
      promises.$promise.then(callback);
      return promises;
    };

    self.getGuardianData = $authentication.getCustomer(); // todo wsithc to highlights call of some sort?
  }]);
